/**
 * @name unregisterLegacyServiceWorker
 * @desc La app ya no usa el Service Worker de Angular (ngsw). Si el navegador conserva el de una version
 * anterior, se desregistra y se borran sus caches (ngsw:*), para que no siga sirviendo una version vieja.
 * Solo toca registros cuyo script es ngsw-worker.js. Como respaldo, /ngsw-worker.js ahora es el
 * safety-worker de Angular (src/ngsw-worker.js), que hace lo mismo al actualizarse.
 */
export function unregisterLegacyServiceWorker(): void {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
        return;
    }
    navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
            for (const registration of registrations) {
                const worker = registration.active ?? registration.waiting ?? registration.installing;
                if (worker?.scriptURL.endsWith('/ngsw-worker.js')) {
                    registration.unregister();
                }
            }
        })
        .catch(() => undefined);

    if (typeof caches !== 'undefined') {
        caches
            .keys()
            .then((names) => Promise.all(names.filter((name) => name.startsWith('ngsw:')).map((name) => caches.delete(name))))
            .catch(() => undefined);
    }
}
